"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum = exports.ShipmentInfosOrderDetailsReturnInformationToJSON = exports.ShipmentInfosOrderDetailsReturnInformationFromJSONTyped = exports.ShipmentInfosOrderDetailsReturnInformationFromJSON = void 0;
var runtime_1 = require("../runtime");
function ShipmentInfosOrderDetailsReturnInformationFromJSON(json) {
    return ShipmentInfosOrderDetailsReturnInformationFromJSONTyped(json, false);
}
exports.ShipmentInfosOrderDetailsReturnInformationFromJSON = ShipmentInfosOrderDetailsReturnInformationFromJSON;
function ShipmentInfosOrderDetailsReturnInformationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'returnType': json['returnType'],
        'returnId': !(0, runtime_1.exists)(json, 'returnId') ? undefined : json['returnId'],
    };
}
exports.ShipmentInfosOrderDetailsReturnInformationFromJSONTyped = ShipmentInfosOrderDetailsReturnInformationFromJSONTyped;
function ShipmentInfosOrderDetailsReturnInformationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'returnType': value.returnType,
        'returnId': value.returnId,
    };
}
exports.ShipmentInfosOrderDetailsReturnInformationToJSON = ShipmentInfosOrderDetailsReturnInformationToJSON;
/**
* @export
* @enum {string}
*/
var ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum;
(function (ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum) {
    ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum["None"] = "none";
    ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum["Pickup"] = "pickup";
    ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum["Bring"] = "bring";
    ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum["Online"] = "online";
    ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum["Before"] = "before";
})(ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum = exports.ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum || (exports.ShipmentInfosOrderDetailsReturnInformationReturnTypeEnum = {}));
//# sourceMappingURL=ShipmentInfosOrderDetailsReturnInformation.js.map